import { useState, useEffect } from 'react';
import {Space, Row, Button, 
    Table, Divider, message, 
    PageHeader, Statistic, Tag,
    Card, Col} from 'antd';

import { Progress } from '@ant-design/plots';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import {
    CheckCircleOutlined,
    SyncOutlined,
    ClockCircleOutlined,
    DeleteOutlined,
  } from '@ant-design/icons';

import TaskAdd from './TaskAdd';
import TaskUpdate from './TaskUpdate';
import axios from 'axios';

const TaskComponent = ()=>{
    const [taskData, setTaskData] = useState()
    const [taskTotal, setTaskTotal] = useState([])

    const [deleteTri, setDeleteTri]=useState(false)
    const [addTri, setAddTri]=useState(false)
    const [updateTri, setUpdateTri]=useState(false)

    const [taskInWaitting, setTaskInWaitting] =useState(0)
    const [taskInPorcess, setTaskInProcess] =useState(0)
    const [taskInFinished, setTaskInFinished] =useState(0)

    useEffect(()=>{

        let getTask = `${FetchVariable.Heroku}/task/`
        axios.get(getTask)
            .then((res)=>{
                let data =res.data
                setTaskData(data)
                setTaskTotal(data.length)
                setDeleteTri(true); 
                setAddTri(true);
                setUpdateTri(true)

                let numbuerOfTaskInWaitting = 0;
                for (let i =0; i< data.length; i++){
                    if(data[i].TaskStatus ===0){
                        numbuerOfTaskInWaitting++
                    }
                }
                setTaskInWaitting(numbuerOfTaskInWaitting)

                let numbuerOfTaskInProcess = 0;
                for (let i =0; i< data.length; i++){
                    if(data[i].TaskStatus ===1){
                        numbuerOfTaskInProcess++
                    }
                }
                setTaskInProcess(numbuerOfTaskInProcess)

                let numbuerOfTaskInFinish = 0;
                for (let i =0; i< data.length; i++){
                    if(data[i].TaskStatus ===2){
                        numbuerOfTaskInFinish++
                    }
                }
                setTaskInFinished(numbuerOfTaskInFinish)

            })
        },[deleteTri, addTri, updateTri]) 


    function deleteTask (deleteID){

        if (deleteTri){
            setDeleteTri(false)
            let deleteTask = `${FetchVariable.Heroku}/task/`+deleteID
            axios.delete(deleteTask)
                .then(message.error('The Task is deleted'))
        }
    }

    const addTask = (addTaskData)=>{

        if (addTri){
            setAddTri(false)
            let apiURL = `${FetchVariable.Heroku}/task/`
            axios.post(apiURL, addTaskData)
            .catch(err=>{console.log(err)})
        }
    }
    const updateTask = (updateTask)=>{
        if (updateTri){

            setUpdateTri(false)
            let apiURL = `${FetchVariable.Heroku}/task/`
            axios.put(apiURL, updateTask)
            .catch(err=>{console.log(err)})
        }
    }

    let vehicleFilter = []
    const key = 'text'
    taskData?.forEach((e)=>{vehicleFilter.push({text:e.VehicleID,value:e.VehicleID})})
    const uniqueMakeFilter = [...new Map(vehicleFilter.map(item =>
    [item[key], item])).values()];

    let vehicleVINFilter = []
    taskData?.forEach((e)=>{vehicleVINFilter.push({text:e.VehicleVIN,value:e.VehicleVIN})})
    const uniqueVehicleVIN = [...new Map(vehicleVINFilter.map(item =>
    [item[key], item])).values()];

    const processConfig = {
        height: 100,
        autoFit: true,
        percent: taskInPorcess/(taskInPorcess+taskInWaitting),
        color: ['#5B8FF9', '#E8EDF3'],
    }

    const TaskColums = [
        {
            title: 'Task ID',
            dataIndex: 'TaskID',
            key: 'TaskID',
            sorter: (a, b) => a.TaskID - b.TaskID,
            defaultSortOrder: 'descend',
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Vehicle ID',
            dataIndex: 'VehicleID',
            key: 'VehicleID',
            filters: uniqueMakeFilter,
            filterSearch: true,
            onFilter: (value, record) => (
                record.VehicleID === value 
            ),
            sorter: (a, b) => a.VehicleID - b.VehicleID,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Vehicle VIN',
            dataIndex: 'VehicleVIN',
            key: 'VehicleVIN',
            width: 250,
            filters: uniqueVehicleVIN,
            filterSearch: true,
            onFilter: (value, record) => (
                record.VehicleVIN === value 
            ),
            sorter: (a, b) => a.VehicleVIN - b.VehicleVIN,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Task',
            dataIndex: 'Task',
            key: 'Task',
            width: 350,
        },
        {
            title: 'Task Status',
            dataIndex: 'TaskStatus',
            key: 'TaskStatus',
            filters:[
                {text:'waitting', value:0},
                {text:'in process', value:1},
                {text:'finished', value:2},
            ],
            onFilter: (value, record) => (
                record.TaskStatus === value 
            ),
            render:(record)=>{
                if (record === 1){return(<Tag icon={<SyncOutlined spin />} color="processing">in processing</Tag>)}
                else if (record === 2){return(<Tag icon={<CheckCircleOutlined />} color="success"> finished</Tag>)}
                else{return(<Tag icon={<ClockCircleOutlined />} color="default">waiting</Tag>)}
            },
            sorter: (a, b) => a.TaskStatus - b.TaskStatus,
            sortDirections: ['descend','ascend'],
        },
        
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
                <Space size="middle">
                <TaskUpdate record={record} updateTask={updateTask}/>
                <Button onClick={()=> deleteTask(record.TaskID) } type="primary" danger icon={<DeleteOutlined />}></Button>
                </Space>
            ),
            },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Task Management"
            extra={[ 
                <TaskAdd key='addTask' addTask={addTask}/>
            ]}
            >
                <div className="site-statistic-demo-card">
                    <Row gutter={16}>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Task In Total"
                                    value={taskTotal}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Task on Waitting"
                                    value={taskInWaitting}
                                    valueStyle={{ color: '#919191' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Task In Process"
                                    value={taskInPorcess}
                                    valueStyle={{ color: '#49a9ee' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Task is Finished"
                                    value={taskInFinished}
                                    valueStyle={{ color: '#3dbd7d' }}
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </PageHeader>
            <Divider orientation="left"> Task Process {((taskInPorcess/(taskInPorcess+taskInWaitting))*100).toFixed(2)}% </Divider>
                <Progress { ...processConfig }/>
            <Row>
                <Table columns={TaskColums} dataSource={taskData} rowKey={(record)=>record.TaskID} scroll={{x:1500, y:1000}}/>
            </Row>
        </>
    )
}

export default TaskComponent